import { ApolloClient } from '@apollo/client';
import { loadRFXRequest, putRFXRequest } from 'gql';
import { AppDispatch, RootState } from 'store';
import { convertRFIRequestFormToRFXRequest, convertRFXRequestToRFIRequestForm } from 'util/transformers';

import { OnRFINaviageUIInput, setRFIIsNew, setRFIWizardData, SLICE_NAME } from './';
import { ThunkApiType } from './types';

interface NavigationHelperProps {
  inputArgs: OnRFINaviageUIInput;
  thunkApi: ThunkApiType;
}

/**
 * Helper class for wizard navigation
 */
export class NavigationHelper {
  apolloClient: ApolloClient<object>;
  dispatch: AppDispatch;
  getState: () => RootState;
  rfxId: string;

  constructor({ inputArgs, thunkApi }: NavigationHelperProps) {
    const { apolloClient, detail } = inputArgs;
    this.apolloClient = apolloClient;

    const { getState, dispatch } = thunkApi;
    this.getState = getState;
    this.dispatch = dispatch;

    const { wizardData } = this.getState()[SLICE_NAME];
    this.rfxId = wizardData.generalInformation.fullRfxId;
  }

  /**
   * Refresh redux wizard data.
   *
   * Load RFXRequest from backend, convert to frontend model, and use it as new redux wizardData
   */
  async refresh() {
    const rfxRequest = await loadRFXRequest({ apolloClient: this.apolloClient, rfxId: this.rfxId, revision: 1 });
    const newRFIRequestForm = convertRFXRequestToRFIRequestForm(rfxRequest);
    this.dispatch(setRFIWizardData(newRFIRequestForm));
  }

  /**
   * Save newly created RFX request.
   */
  async saveNew() {
    const { wizardData } = this.getState()[SLICE_NAME];

    // TODO: add error handling
    const convertedData = convertRFIRequestFormToRFXRequest(wizardData);

    // Save changes
    await putRFXRequest({
      apolloClient: this.apolloClient,
      rfxRequest: convertedData
    });

    this.dispatch(setRFIIsNew(false));
  }

  /**
   * Save changed RFX request.
   */
  async save() {
    // Sync-up request version
    // TODO: notify user if version is changed
    const rfxRequest = await loadRFXRequest({ apolloClient: this.apolloClient, rfxId: this.rfxId, revision: 1 });
    console.log(rfxRequest);
    let { wizardData } = this.getState()[SLICE_NAME];
    if (wizardData.rfxRequestVersion !== rfxRequest.rfxRequestVersion) {
      wizardData = {
        ...wizardData,
        rfxRequestVersion: rfxRequest.rfxRequestVersion
      };
    }
    // Save changes
    await putRFXRequest({
      apolloClient: this.apolloClient,
      rfxRequest: convertRFIRequestFormToRFXRequest(wizardData)
    });
  }
}
